import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import fetch from 'utils/fetch';
import { error } from 'plugins/toastr';
import { hideLoader } from 'plugins/loader';
import moment from 'moment';
import { renderList, renderCheckboxList } from 'utils/async-list';
import { withReferer } from 'plugins/contextual-back';
import renderManipulations, {
  serializeStore,
  serializeForm,
} from './manipulations';
import bindCreation from './creation';
import { Column } from 'react-virtualized';
import Signature from './components/Signature';
import ProductTable from './components/ProductTable';
import schedule from './schedule';
import {
  renderCaseCustomer,
  onTargetClickAction,
} from 'modules/saas/common/columns';
import { Set } from 'immutable';
import {
  displayConfirmModalIfNeeded,
  displayCancelModal,
} from './validation/confirm-validation';
import { displayValidationErrorModalIfNeeded } from './validation/error-validation';
import renderToValidateRow from './validation/renderToValidateRow';
import { uploadFile } from './manipulations/api';
import PlanningModal from '../../aast/interventions/modal/PlanningModal';

require('plugins/are-you-sure');

export function generality(ctx) {
  $('input[name=delay]').on('change', () => {
    $('input.delayRelated').val('');
  });

  common(ctx);
  schedule();
}

export function task(ctx) {
  // Rendering manipulations
  const store = renderManipulations(ctx.params.id);
  common(ctx, store);
}

export function observation(ctx) {
  common(ctx);

  const $productTraceability = document.getElementById('product-traceability');
  const $noDelayCheckbox = $('#securityNoDelayCheckbox');
  const $dateDelayCheckbox = $('#securityDateDelayCheckbox');
  const $dateDelayInputs = $dateDelayCheckbox.siblings('.fields').find('input');

  if ($noDelayCheckbox.checkbox('is checked')) {
    $dateDelayInputs.each((index, elem) => {
      $(elem).val(null);
      $(elem).prop('disabled', true);
    });
  }

  $noDelayCheckbox.checkbox({
    onChange: evt => {
      if ($noDelayCheckbox.checkbox('is checked')) {
        $dateDelayInputs.each((index, elem) => {
          $(elem).val(null);
          $(elem).prop('disabled', true);
        });
      }
    },
  });

  $dateDelayCheckbox.checkbox({
    onChange: evt => {
      if ($dateDelayCheckbox.checkbox('is checked')) {
        $dateDelayInputs.prop('disabled', false);
      }
    },
  });

  if ($productTraceability) {
    const products = __INITIAL_DATA__;
    // Handling product traceability components
    ReactDOM.render(
      <ProductTable products={Set(products)} />,
      $productTraceability
    );
  }
}

export function validation(ctx) {
  const $signature = document.getElementById('signature');

  const name = $signature.dataset.name;
  const value = $signature.dataset.value;
  const thumbnail = $signature.dataset.thumbnail;
  const $disabled = !!$($signature).attr('disabled');

  // Building resource
  const resource = {
    id: value,
    web: thumbnail,
  };

  // Handling signature component
  ReactDOM.render(
    <Signature name={name} resource={resource} disabled={$disabled} />,
    $signature
  );

  common(ctx);
}

function alterFieldWithIndex($form, fieldSelector) {
  $form.find(fieldSelector).each((_, elem) => {
    const currentName = $(elem).attr('name');
    const newName = currentName.replace('[]', `[${$(elem).data('index')}]`);
    $(elem).attr('name', newName);
  });
}
function appendFormattedComplexListFields($form) {
  alterFieldWithIndex($form, '[name="complexList.complex_refs[].ref"]');
  alterFieldWithIndex($form, '[name="complexList.complex_refs[].text1"]');
  alterFieldWithIndex($form, '[name="complexList.complex_refs[].text2"]');
}

//EW
function cleanComplexRefData(data) {
  let toDelete = [];
  for (let pair of data.entries()) {
    if (!pair[1]) {
      toDelete.push(pair[0]);
    }
  }

  for (let key of toDelete) {
    data.delete(key);
  }
}

function common(ctx, store) {
  // Enable dirty form
  $('form.ui.form').areYouSure();

  appendFormattedComplexListFields($('section.customers form'));

  let nextAction, nextMethod;

  // Handling form submission
  $('section.customers form').on('submit', evt => {
    evt.preventDefault();

    // Check another action must be executed after save
    const $button = $(document.activeElement);
    const action = $button.attr('data-action') || nextAction;
    const method = $button.attr('data-method') || nextMethod || 'PUT';

    nextAction = null;
    nextMethod = null;

    const $form = $(evt.currentTarget);

    const data = serializeForm($form);

    const handleBeforeImageManipImageSave = m => {
      if (m && m.image_before) {
        if (m.image_before === 'deleted') {
          return Promise.resolve(
            Object.assign({
              ...m,
              image_before: undefined,
              image_before_id: undefined,
            })
          );
        } else {
          return uploadFile(m.image_before).then(
            resJson =>
              Object.assign({
                ...m,
                image_before: undefined,
                image_before_id: resJson.resource,
              }),
            err => {
              console.log('Failed to save file');
              return Promise.resolve(Object.assign({ ...m }));
            }
          );
        }
      } else {
        return Promise.resolve(Object.assign({ ...m }));
      }
    };

    const handleAfterImageManipImageSave = m => {
      if (m && m.image_after) {
        if (m.image_after === 'deleted') {
          return Promise.resolve(
            Object.assign({
              ...m,
              image_after: undefined,
              image_after_id: undefined,
            })
          );
        } else {
          return uploadFile(m.image_after).then(
            resJson =>
              Object.assign({
                ...m,
                image_after: undefined,
                image_after_id: resJson.resource,
              }),
            err => {
              console.log('Failed to save file');
              return Promise.resolve(Object.assign({ ...m }));
            }
          );
        }
      } else {
        return Promise.resolve(Object.assign({ ...m }));
      }
    };

    const handleCreatedManipResourceSave = manip => {
      const imageBeforeAction = handleBeforeImageManipImageSave(manip);
      const imageAfterAction = updated =>
        handleAfterImageManipImageSave(updated);

      return imageBeforeAction.then(res => imageAfterAction(res));
    };

    const handleEditManipResourceSave = (key, manip) => {
      const imageBeforeAction = handleBeforeImageManipImageSave(manip);
      const imageAfterAction = updated =>
        handleAfterImageManipImageSave(updated);

      return imageBeforeAction
        .then(res => imageAfterAction(res))
        .then(res => [key, res]);
    };

    // Submitting
    const url = $form.attr('action');

    cleanComplexRefData(data);

    // Adding manipulations to form data

    const saveInterventionAction = () =>
      fetch(url, {
        method: 'POST',
        body: data,
      })
        .then(res => {
          if (action && method) {
            return fetch(action, {
              method,
            });
          } else {
            return Promise.resolve(res);
          }
        })
        .then(
          res => window.location.replace(res.url),
          err => {
            console.log('Error attempting to save intervention', err);

            const errorHeader = err.res.headers.get('errorCustom');
            let errorLabel;

            if (errorHeader) {
              errorLabel = errorHeader;
            } else {
              errorLabel =
                "Une erreur est survenue pendant la sauvegarde de l'intervention";
            }

            hideLoader();
            const modalValidateButton = $(
              '#confirm-action-modal div.actions .approve'
            );
            const validateButton = $('#bt-validate-intervention');

            if (modalValidateButton) modalValidateButton.removeClass('loading');
            if (validateButton) validateButton.removeClass('loading');

            error(errorLabel);
          }
        );

    if (store) {
      const manipulations = serializeStore(store);

      let manipulationsMutable = {
        created: manipulations.created,
        updated: manipulations.updated,
        deleted: manipulations.deleted,
      };

      const saveUpdatedImagePromise = () =>
        Promise.all(
          Object.entries(manipulations.updated).map(entry =>
            handleEditManipResourceSave(entry[0], entry[1])
          )
        ).then(values => {
          manipulationsMutable.updated = Object.fromEntries(values);
        });

      Promise.all(
        manipulations.created.map(m => handleCreatedManipResourceSave(m))
      )
        .then(values => {
          manipulationsMutable.created = values;
        })
        .then(saveUpdatedImagePromise)
        .then(_ => {
          data.append('manips', JSON.stringify(manipulationsMutable));
        })
        .then(saveInterventionAction);
    } else {
      saveInterventionAction();
    }

    return false;
  });

  const validateInterventionAction = $button => () => {
    const url = $button.attr('data-action');
    const method = $button.attr('data-method') || 'PUT';

    nextAction = url;
    nextMethod = method;

    $('#confirm-action-modal div.actions .approve').addClass('loading');

    $('section.customers form').trigger('submit');
  };

  $('#bt-validate-intervention').on('click', function(evt) {
    evt.preventDefault();
    const idsArray = Array.of($(evt.target).data('id'));
    const errorsCount = $(evt.target).data('errors');
    if (idsArray && idsArray.length) {
      // Serialize ids as JSON and execute given URL
      const jsonBody = JSON.stringify(idsArray);
      const $button = $(evt.currentTarget);
      const $action = validateInterventionAction($button, jsonBody);

      if (errorsCount && parseInt(errorsCount, 10)) {
        displayValidationErrorModalIfNeeded(errorsCount);
      } else {
        displayConfirmModalIfNeeded(idsArray, () => {
          $button.addClass('loading');
          $action().catch(err => {
            console.log('Error attempting to execute selection action', err);

            $button.removeClass('loading');
            error('Une erreur est survenue. Merci de réessayer ultérieurement');
          });
        });
      }
    }
  });

  $('#bt-cancel-intervention').on('click', evt => {
    evt.preventDefault();

    const $button = $(evt.target);
    const action = $button.attr('data-action');
    const method = $button.attr('data-method') || 'PUT';

    nextAction = action;
    nextMethod = method;

    displayCancelModal(() => {
      $('section.customers form').trigger('submit');
    });
  });

  const regenerateReport = (url, $button) =>
    fetch(url, {
      method: 'POST',
    }).then(
      res => window.location.replace(res.url),
      err => {
        console.log('Error attempting to regenerate report', err);

        $button.removeClass('loading');
        error('Une erreur est survenue. Merci de réessayer ultérieurement');
      }
    );

  $('#bt-regenerate-report').on('click', function(evt) {
    evt.preventDefault();

    const $button = $(evt.target);
    const action = $button.attr('data-action');
    const method = $button.attr('data-method');
    $button.addClass('loading');

    if (action && method) regenerateReport(action, $button);
  });
}

// TODO: Create intervention listing urls server side (by customer and case)

export function byCustomer(ctx) {
  const customerId = ctx.params.id;

  renderWithoutCheckbox(
    `/pco-manager/customers/${customerId}/interventions.json`,
    `/pco-manager/customers/${customerId}/interventions`
  );

  bindCreation(customerId);
}

export function byCase(ctx) {
  const caseId = ctx.params.id;
  const customerId = $('#case-data').attr('data-customer');

  renderWithoutCheckbox(
    `/pco-manager/cases/${caseId}/interventions.json`,
    `/pco-manager/cases/${caseId}/interventions`
  );

  bindCreation(customerId, caseId, 0);
}

export function bySite(ctx) {
  const siteId = ctx.params.id;
  const customerId = $('#site-data').attr('data-customer');

  renderWithoutCheckbox(
    `/pco-manager/sites/${siteId}/interventions.json`,
    `/pco-manager/sites/${siteId}/interventions`
  );

  bindCreation(customerId, 0, siteId);
}

export function byEntityToPlan() {
  const referer = '/pco-manager/workflow/interventions/toplan';

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/interventions/${id}`, referer);
  const loadNextUrl = '/pco-manager/workflow/interventions/toplan.json';

  renderList(rowClickedUrl, loadNextUrl, renderToPlanColumns);
}

function getFetchAction($button, jsonBody) {
  const url = $button.attr('data-action');
  const method = $button.attr('data-method') || 'PUT';

  if (url && url.length) {
    return () =>
      fetch(url, {
        headers: {
          'Content-Type': 'application/json',
        },
        method,
        body: jsonBody,
      }).then(res => {
        $button.removeClass('loading');
        window.location.replace(res.url);
      });
  }

  return null;
}

const handleValidateTableClick = evt => {
  evt.preventDefault();
  evt.stopPropagation();

  const idsArray = Array.of($(evt.target).data('id'));
  if (idsArray && idsArray.length) {
    // Serialize ids as JSON and execute given URL
    const jsonBody = JSON.stringify(idsArray);
    const $button = $(evt.currentTarget);
    const $action = getFetchAction($button, jsonBody);
    displayConfirmModalIfNeeded(idsArray, () => {
      $button.addClass('loading');
      $action().catch(err => {
        console.log('Error attempting to execute selection action', err);

        const errorHeader = err.res.headers.get('errorCustom');
        let errorLabel;

        if (errorHeader) {
          errorLabel = errorHeader;
        } else {
          errorLabel =
            'Une erreur est survenue. Merci de réessayer ultérieurement';
        }
        $button.removeClass('loading');
        error(errorLabel);
      });
    });
  }
};

export function byEntityToValidate() {
  const referer = '/pco-manager/workflow/interventions/tovalidate';

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/interventions/${id}`, referer);
  const loadNextUrl = '/pco-manager/workflow/interventions/tovalidate.json';

  renderCheckboxList(
    rowClickedUrl,
    loadNextUrl,
    renderToValidateColumns,
    renderToValidateRow
  );

  $('.actionBar .button.selection.validation').on('click', function(evt) {
    evt.preventDefault();
    const selectedIds = $('.actionBar')
      .find('#selected-ids')
      .attr('data-value');
    if (selectedIds && selectedIds.length) {
      // Serialize ids as JSON and execute given URL
      const idsArray = selectedIds.split(',').map(Number);
      const jsonBody = JSON.stringify(idsArray);
      const $button = $(evt.currentTarget);
      const $action = getFetchAction($button, jsonBody);
      displayConfirmModalIfNeeded(idsArray, () => {
        $button.addClass('loading');
        $action().catch(err => {
          console.log('Error attempting to execute selection action', err);

          const errorHeader = err.res.headers.get('errorCustom');
          let errorLabel;

          if (errorHeader) {
            errorLabel = errorHeader;
          } else {
            errorLabel =
              'Une erreur est survenue. Merci de réessayer ultérieurement';
          }
          $button.removeClass('loading');
          error(errorLabel);
        });
      });
    }
  });
}

export function byEntityNotExecuted() {
  const referer = '/pco-manager/workflow/interventions/notexecuted';

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/interventions/${id}`, referer);
  const loadNextUrl = '/pco-manager/workflow/interventions/notexecuted.json';

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderNotExecutedColumns);
}

function displayModal(modal) {
  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#modal-root');

  $modal
    .modal({
      onApprove: element => {},
      autofocus: false,
    })
    .modal('show');
}

const displayPlanningModal = (id, caseId) => {
  const root = document.getElementById('modal-root');
  const workersData = window.__WORKERS__;

  const onClose = () => {
    $(root).modal('hide');
  };

  if (root && workersData) {
    ReactDOM.unmountComponentAtNode(root);

    const modalContent = ReactDOM.render(
      <PlanningModal
        id={'PCO_' + id}
        caseId={caseId}
        workers={workersData}
        onClose={onClose}
      />,
      root
    );
    displayModal(modalContent);
  }
};

function renderWithoutCheckbox(url, from) {
  const rowClickedUrl = id =>
    withReferer(`/pco-manager/interventions/generality/${id}`, from);
  const loadNextUrl = url;

  renderList(rowClickedUrl, loadNextUrl, renderColumns);
}

/*function renderWithCheckbox(url, from) {
  const rowClickedUrl = id =>
    withReferer(`/pco-manager/interventions/generality/${id}`, from);
  const loadNextUrl = url;

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderColumns);
}*/

const renderPreplanningDate = preplanningDate => {
  const date = moment(preplanningDate, 'DD/MM/YYYY').weekday(0);
  const week = date.isoWeek();
  const year = date.get('year');

  return `Semaine ${week} (${year})`;
};

const renderSimpleDate = rowDate => {
  return moment(rowDate, 'DD/MM/YYYY').format('DD/MM/YYYY');
};

function renderDate({ rowData }) {
  let label;

  switch (rowData.status) {
    case 'TO_PLAN':
      label = '';
      break;
    case 'PREPLANNED':
      label = renderPreplanningDate(rowData.preplanning_date);
      break;
    case 'PLANNED':
      if (rowData.planning_date) {
        label = renderSimpleDate(rowData.planning_date);
      } else if (rowData.preplanning_date) {
        label = renderPreplanningDate(rowData.preplanning_date);
      } else {
        label = '';
      }
      break;
    case 'RUNNING':
      if (rowData.planning_date) {
        label = renderSimpleDate(rowData.planning_date);
      } else if (rowData.preplanning_date) {
        label = renderPreplanningDate(rowData.preplanning_date);
      } else {
        label = '';
      }
      break;
    case 'WAITING_SYNC':
      if (rowData.planning_date) {
        label = renderSimpleDate(rowData.planning_date);
      } else if (rowData.preplanning_date) {
        label = renderPreplanningDate(rowData.preplanning_date);
      } else {
        label = '';
      }
      break;
    case 'NOT_EXECUTED':
      if (rowData.planning_date) {
        label = renderSimpleDate(rowData.planning_date);
      } else if (rowData.preplanning_date) {
        label = renderPreplanningDate(rowData.preplanning_date);
      } else {
        label = '';
      }
      break;
    case 'NOT_EXECUTED_JUSTIF':
      if (rowData.planning_date) {
        label = renderSimpleDate(rowData.planning_date);
      } else if (rowData.preplanning_date) {
        label = renderPreplanningDate(rowData.preplanning_date);
      } else {
        label = '';
      }
      break;
    case 'CANCELED':
      if (rowData.planning_date) {
        label = renderSimpleDate(rowData.planning_date);
      } else if (rowData.preplanning_date) {
        label = renderPreplanningDate(rowData.preplanning_date);
      } else {
        label = '';
      }

      break;
    case 'EXECUTED':
      label = renderSimpleDate(rowData.execution_date);
      break;
    case 'VALIDATED':
      label = renderSimpleDate(rowData.execution_date);
      break;
    default:
      break;
  }

  return label;
}

function renderStatus({ rowData, style, key }) {
  let label, title, opt;

  switch (rowData.status) {
    case 'TO_PLAN':
      label = 'ui orange label';
      title = 'A planifier';
      break;
    case 'PREPLANNED':
      label = 'ui orange label';
      title = 'Pré-planifiée';
      break;
    case 'PLANNED':
      label = 'ui green label';
      title = 'Planifiée';
      break;
    case 'EXECUTED':
      label = 'ui green label';
      title = 'Exécutée';
      break;
    case 'RUNNING':
      label = 'ui green label';
      title = 'En cours';
      break;
    case 'WAITING_SYNC':
      label = 'ui red label';
      title = 'En attente de rapport';
      break;
    case 'NOT_EXECUTED':
      label = 'ui red label';
      title = 'Non saisie';
      break;
    case 'NOT_EXECUTED_JUSTIF':
      label = 'ui red label';
      title = 'Non réalisée';
      opt = rowData.justif;
      break;
    case 'CANCELED':
      label = 'ui grey label';
      title = 'Annulée';
      break;
    case 'VALIDATED':
      label = 'ui grey label';
      title = 'Validée';
      break;
    default:
      break;
  }

  if (label && title) {
    if (opt) {
      return (
        <span
          key={key}
          className={label}
          data-tooltip={opt}
          style={style}
          data-position="left center"
        >
          {title}
        </span>
      );
    } else {
      return <span className={label}>{title}</span>;
    }
  }

  return null;
}

function renderColumns(width) {
  return [
    <Column key="site" dataKey="site" width={(width / 16) * 3} label="Site" />,
    <Column
      key="category"
      dataKey="category"
      width={(width / 16) * 2}
      label="Catégorie"
    />,
    <Column
      key="contract_status"
      dataKey="contract_status"
      width={(width / 16) * 2}
      label="Statut contractuel"
    />,
    <Column
      key="status"
      dataKey="status"
      cellRenderer={renderStatus}
      width={(width / 16) * 2}
      label="Statut"
    />,
    <Column
      key="date"
      dataKey="date"
      cellRenderer={renderDate}
      width={(width / 16) * 2}
      label="Date"
    />,
    <Column
      key="work_type"
      dataKey="work_type"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 6}
      label="Travaux"
    />,
  ];
}

function renderToPlanColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={(width / 16) * 5}
      label="Chantier"
    />,
    <Column key="site" dataKey="site" width={(width / 16) * 7} label="Site" />,
    <Column
      key="tasks"
      dataKey="tasks"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 4}
      label="Travaux"
    />,
  ];
}

const renderTasks = ({ rowData }) => {
  return (
    <span>
      <strong>{rowData.worker_name}</strong>
      <br />
      {rowData.tasks}
    </span>
  );
};

const renderValidateAction = ({ rowData }) => {
  const id = rowData.id;

  const renderButton = (
    <a
      className="ui basic green button selection validation"
      onClick={handleValidateTableClick}
      data-id={id}
      data-action="/pco-manager/workflow/interventions/tovalidate"
      data-method="PUT"
    >
      <i className="checkmark icon" />
      Valider
    </a>
  );

  const renderError = (
    <strong>
      <i className="warning sign icon" /> Erreurs
    </strong>
  );

  const renderBlocking = (
    <a
      className="ui basic red button selection validation"
      onClick={handleValidateTableClick}
      data-id={id}
      data-action="/pco-manager/workflow/interventions/tovalidate"
      data-method="PUT"
    >
      <i className="warning sign icon" />
      Valider
    </a>
  );

  return rowData.error_count
    ? renderError
    : rowData.is_blocking
    ? renderBlocking
    : renderButton;
};

function renderToValidateColumns(width) {
  return [
    <Column
      key="id"
      dataKey="id"
      cellRenderer={renderValidateAction}
      width={(width / 16) * 2}
      label="Action"
      disableSort
    />,
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={(width / 16) * 3.5}
      label="Nom du chantier"
    />,
    <Column
      key="site_name"
      dataKey="site_name"
      width={(width / 16) * 2.5}
      label="Site"
    />,
    <Column
      key="category"
      dataKey="category"
      width={(width / 16) * 2}
      label="Catégorie"
    />,
    <Column
      key="contractual_status"
      dataKey="contractual_status"
      width={(width / 16) * 2}
      label="Statut contractuel"
    />,
    <Column
      key="execution_date"
      dataKey="execution_date"
      width={(width / 16) * 1.5}
      label="Date"
    />,
    <Column
      key="tasks"
      dataKey="tasks"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 3.5}
      cellRenderer={renderTasks}
      label="Diagnostics"
    />,
  ];
}

const renderNotExecutedActions = ({ rowData }) => {
  const id = rowData.id;

  const onDeleteClick = evt => {
    const target = evt.currentTarget;
    evt.stopPropagation();
    displayCancelModal(() => {
      onTargetClickAction($(target), id, 'Error during intervention treatment');
    });
  };

  const onReplanClick = evt => {
    evt.preventDefault();
    evt.stopPropagation();

    displayPlanningModal(id, rowData.case_id);
  };

  const renderButton = (
    <div className="ui buttons">
      <a className="ui basic green button" onClick={onReplanClick}>
        <i className="undo icon" />
        Replanifier
      </a>
      <a
        className="ui basic grey button"
        onClick={onDeleteClick}
        data-action="/pco-manager/workflow/interventions/notexecuted"
        data-method="DELETE"
      >
        <i className="remove icon" />
        Annuler
      </a>
    </div>
  );

  return renderButton;
};

function renderNotExecutedColumns(width) {
  return [
    <Column
      key="id"
      dataKey="id"
      cellRenderer={renderNotExecutedActions}
      width={(width / 16) * 3.5}
      label="Action"
      disableSort
    />,
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={(width / 16) * 2.8}
      label="Chantier"
    />,
    <Column
      key="site_name"
      dataKey="site_name"
      width={(width / 16) * 1.5}
      label="Site"
    />,
    <Column
      key="category"
      dataKey="category"
      width={(width / 16) * 1.2}
      label="Catégorie"
    />,
    <Column
      key="planning_date"
      dataKey="planning_date"
      width={(width / 16) * 1.5}
      label="Date"
    />,
    <Column
      key="tasks"
      dataKey="tasks"
      width={(width / 16) * 2.5}
      cellRenderer={renderTasks}
      label="Travaux"
    />,
    <Column
      key="status"
      dataKey="status"
      headerClassName="right aligned"
      className="right aligned of-visible"
      width={(width / 16) * 2}
      cellRenderer={renderStatus}
      label="Statut"
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/index.js